module.exports = __webpack_public_path__ + "static/media/summit-face-register-intro.4f5437b2.svg";